<template>
    <el-select 
        placeholder="请选择工单状态"
        v-model="dataValue"
        @change="ticketStatusChange_1"
        style="width: 100%;">
        <el-option v-for="item in ticketStatusList"
            :key="item.value"
            :label="item.name"
            :value="item.value"/>
    </el-select>
</template>

<script>
export default {
    name: 'TicketStatusSelect',

    props: ['value'],

    data() {
        return {
            dataValue: null,
            ticketStatusList: []
        }
    },

    watch: {
        value() {
            this.setDataValue(this.value);
        }
    },

    mounted() {
        this.setDataValue(this.value);

        this.listTicketStatus();
    },

    methods: {
        pushOneToTicketStatusList(one) {
            if (!one) {
                return;
            }

            for (let i=0; i < this.ticketStatusList.length; i++) {
                if((this.ticketStatusList[i].id && one.id && this.ticketStatusList[i].id == one.id) //
                    || (this.ticketStatusList[i].value && one.value && this.ticketStatusList[i].value == one.value) // 
                    || (this.ticketStatusList[i].id && one.value &&  this.ticketStatusList[i].id == one.value) //
                    || (this.ticketStatusList[i].value && one.id &&  this.ticketStatusList[i].value == one.id)) {
                    console.log('#48 pushOneToTicketStatusList, not push one', one, 'me', this.ticketStatusList[i]);
                    return; // 如果包含就 return
                }
            }

            this.ticketStatusList.push(one);
        },

        pushListToTicketStatusList(list) {
            if (!list) {
                return;
            }

            for (let i=0; i < list.length; i++){
                this.pushOneToTicketStatusList(list[i]);
            }

            //console.log('#65', this.ticketStatusList);
        },

        setDataValue() {
            var _this = this;

            // 所有状态
            sdk.TicketStatusApi().findByValue({
                value : _this.value
            }).then(res => {
                _this.pushOneToTicketStatusList(res)

                _this.dataValue = _this.value;
            });
        },

        listTicketStatus() {
            var _this = this;

            // 所有状态
            sdk.TicketStatusApi().listCached({
                page : { pageSize : 9999 }
            }).then(res => {
                _this.pushListToTicketStatusList(res);
            });
        },

        ticketStatusChange_1(val) {
            this.$emit('change', val);
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketStatusSelect.vue